module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位名称",
      "prop": "danwei",
      "rules": [{
        required: true,
        message: '请输入单位名称',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考级时间",
      "prop": "datetitle",
      "rules": [{
        required: true,
        message: '请选择考级时间'
      } ]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "date",
      "placeholder": "请选择考级时间"
    },
    model: {
      value: (_vm.formData.datetitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "datetitle", $$v)
      },
      expression: "formData.datetitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考试星级",
      "prop": "star_type",
      "rules": [{
        required: true,
        message: '请选择考试星级'
      } ]
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.formData.star_type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "star_type", $$v)
      },
      expression: "formData.star_type"
    }
  }, _vm._l((_vm.starList), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.text
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市地区",
      "prop": "area",
      "rules": [{
        required: true,
        message: '请选择地区',
      } ]
    }
  }, [_c('el-cascader', {
    ref: "areas",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleAreasChange
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考级地址",
      "prop": "address",
      "rules": [{
        required: true,
        message: '请输入考级地址',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入考级地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "本机构考官",
      "prop": "jigou",
      "rules": []
    }
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onKaoguanShow
    }
  }, [_vm._v("请选择人员 "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jigoukaoguan.length > 0),
      expression: "formData.jigoukaoguan.length>0"
    }]
  }, _vm._l((_vm.formData.jigoukaoguan), function(kaoguan, index) {
    return _c('div', {
      key: index,
      staticClass: "memberLi"
    }, [_c('el-tag', {
      key: index,
      attrs: {
        "round": "",
        "closable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.jigoukaoguan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(kaoguan.name) + "(" + _vm._s(kaoguan.grade) + ")\n                ")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("本机构考官选填")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "非机构考官",
      "prop": "no-jigou",
      "rules": []
    }
  }, [_c('el-button', {
    attrs: {
      "type": "mini"
    },
    on: {
      "click": _vm.getKaoguanRand
    }
  }, [_vm._v(_vm._s(_vm.kaoguanWaitList.length > 0 ? '更换一波' : '随机筛选') + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "kaoguan-box"
  }, [_c('div', {
    staticStyle: {
      "border-top": "1px solid #eeee",
      "padding": "5px 0 5px 10px"
    }
  }, [_vm._v("已选考官名单")]), _vm._v(" "), _vm._l((_vm.formData.kaoguan), function(kaoguan, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "round": "",
        "closable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.kaoguan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(kaoguan.name) + "(" + _vm._s(kaoguan.grade) + ") "), _c('a', {
      attrs: {
        "href": 'tel:' + kaoguan.phone
      }
    }, [_vm._v(_vm._s(kaoguan.phone))])])
  })], 2), _vm._v(" "), (_vm.kaoguanWaitList.length > 0) ? _c('div', {
    staticClass: "kaoguan-box"
  }, [_c('div', {
    staticStyle: {
      "border-top": "1px solid #eeee",
      "padding": "5px 0 5px 10px"
    }
  }, [_vm._v("待选考官")]), _vm._v(" "), _vm._l((_vm.kaoguanWaitList), function(kaoguan, index) {
    return _c('van-tag', {
      key: index,
      attrs: {
        "size": "large",
        "plain": "",
        "closable": "",
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(kaoguan.name) + "(" + _vm._s(kaoguan.grade) + ") "), _c('span', [_vm._v(_vm._s(kaoguan.phone))]), _vm._v(" "), _c('div', {
      staticClass: "small-button",
      staticStyle: {
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.onKaoguanChoose(kaoguan)
        }
      }
    }, [_vm._v("选择")])])
  })], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "监督选择",
      "prop": "jiandu",
      "rules": []
    }
  }, [_c('el-button', {
    attrs: {
      "type": "mini"
    },
    on: {
      "click": _vm.getJianduRand
    }
  }, [_vm._v(_vm._s(_vm.formData.jiandu.length > 0 ? '更换一波' : '随机筛选') + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "kaoguan-box"
  }, _vm._l((_vm.formData.jiandu), function(jiandu, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "round": "",
        "closable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.jiandu.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(jiandu.name) + " "), _c('a', {
      attrs: {
        "href": 'tel:' + jiandu.phone
      }
    }, [_vm._v(_vm._s(jiandu.phone))])])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话",
      "prop": "phone",
      "rules": [{
        required: true,
        validator: _vm.validator.phone,
        message: '请输入日常联系人电话',
        trigger: ['blur', 'change']
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入日常联系人电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('KaoguanPicker', {
    attrs: {
      "show": _vm.showKaoguanPicker,
      "limit": 1,
      "grade": _vm.grade,
      "isStartLoading": false,
      "defaultValue": _vm.formData.jigoukaoguan
    },
    on: {
      "onChange": _vm.onKaoguanChange,
      "onClose": function($event) {
        _vm.showKaoguanPicker = false
      },
      "onConfirm": _vm.onKaoguanConfirm
    }
  }), _vm._v(" "), _c('JianduPicker', {
    attrs: {
      "show": _vm.showJianduPicker,
      "limit": 1,
      "defaultValue": _vm.formData.jiandu
    },
    on: {
      "onChange": _vm.onJianduChange,
      "onClose": function($event) {
        _vm.showJianduPicker = false
      },
      "onConfirm": _vm.onJianduConfirm
    }
  }), _vm._v(" "), _c('CenterPicker', {
    attrs: {
      "show": _vm.showCenterPicker,
      "limit": 1,
      "defaultValue": _vm.formData.extra_center
    },
    on: {
      "onChange": _vm.onCenterChange,
      "onClose": function($event) {
        _vm.showCenterPicker = false
      },
      "onConfirm": _vm.onCenterConfirm
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "title": "选择年月日",
      "type": "date",
      "default-date": new Date((_vm.formData.datetitle ? _vm.formData.datetitle : "").replace(/-/g, "/")),
      "min-date": _vm.minDate
    },
    on: {
      "cancel": function($event) {
        _vm.showDate = false
      },
      "confirm": _vm.onDateConfirm
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dc64ab3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyFormBasicMine.vue
// module id = 1396
// module chunks = 0